export default class StringUtils {
    static replace(str, ...args) {
        let result = str;
        args.forEach((arg, index) => {
            const regex = new RegExp(`{${index}\\}`, 'g');
            result = result.replace(regex, arg);
        });
        return result;
    }

    static equalsIgnoreCase(str1, str2) {
        return (str1 ?? '').trim().toLowerCase() === (str2 ?? '').trim().toLowerCase();
    }
}
